module.exports = __webpack_public_path__ + "img/image32.ff0e5058.png";